<template>
  <h1 class="c-common-heading1" :class="{ '-block-large-sp': blockLargeSp }">
    <slot></slot>
    <span v-if="$slots.text">
      <slot name="text"></slot>
    </span>
    <span class="c-common-heading1__button" v-if="$slots.button">
      <slot name="button"></slot>
    </span>
  </h1>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
	props: {
	    blockLargeSp: {
	      type: Boolean,
	      default: false
	    }
	  }
})

export default class CommonHeading extends Vue {
  blockLargeSp!: boolean;
}
</script>

<style lang="scss" scoped>
.c-common-heading1 {
  font-size: rem(20);
  font-weight: bold;
  display: flex;
  align-items: center;

  @include sp {
    font-size: rem(14);
  }

  &.-block-large-sp {
    @include large-sp {
      display: block;
    }
  }

  &__button {
    margin-left: auto;
    margin-right: 0;
    display: flex;

    @include large-sp {
      display: block;
    }
  }

  &.-block-large-sp &__button {
    @include large-sp {
      margin-top: rem(24);
    }
  }
}
</style>
